import * as React from 'react';

export function SvgBitbucket(props: any) {
  return (
    <svg
      {...props}
      viewBox="0 0 24 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.770441 0C0.290891 0 -0.0687694 0.43959 0.0111506 0.87918L3.24814 20.7007C3.32806 21.2203 3.76766 21.5799 4.28717 21.5799H19.9526C20.3123 21.5799 20.632 21.3002 20.7119 20.9405L23.9888 0.91915C24.0688 0.43959 23.7091 0.0399699 23.2296 0.0399699L0.770441 0ZM14.5177 14.3067H9.5223L8.2035 7.2333H15.7565L14.5177 14.3067Z"
        fill="#2684FF"
      />
      <path
        d="M22.9098 7.23331H15.7165L14.5176 14.3067H9.52219L3.64771 21.3002C3.64771 21.3002 3.92744 21.54 4.32707 21.54H19.9925C20.3522 21.54 20.6719 21.2602 20.7518 20.9005L22.9098 7.23331Z"
        fill="url(#paint0_linear_1_5)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_1_5"
          x1="24.5925"
          y1="9.22651"
          x2="12.672"
          y2="18.5316"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.176" stopColor="#0052CC" />
          <stop offset="1" stopColor="#2684FF" />
        </linearGradient>
      </defs>
    </svg>
  );
}
